import { ApiResponse } from "@payment-client/interfaces/Api";
import { makeDownstreamApiCall } from "@payment-client/utils/Api";
import { IRewardOfferNewCard } from "@swiggy-private/payment-ui";
import { DOWNSTREAM_ENDPOINTS } from "@payment-client/constants/Hosts";
import { getSplitpayMethodsNameAsArray } from "@payment-client/helpers/SplitPay";

// Added for new flow for reward
export async function checkOfferAndRewardOnNewCardAPI(
    apiHost: string,
    cardBin: string,
    splitpayMethods: string,
): Promise<ApiResponse<IRewardOfferNewCard>> {
    const _splitpayMethods = Array.from(new Set(getSplitpayMethodsNameAsArray(splitpayMethods)));
    const response = await makeDownstreamApiCall<ApiResponse<IRewardOfferNewCard>>({
        apiHost,
        endpoint: DOWNSTREAM_ENDPOINTS.CHECK_OFFER_AND_REWARD_ON_NEW_CARD,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        bodyParams: { card_bin: cardBin, split_pay_methods: _splitpayMethods },
        options: {
            method: "POST",
        },
    });
    return response;
}
